/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ManagerAccountControllerDtoNotificationTokenCreateRequest model module.
 * @module model/ManagerAccountControllerDtoNotificationTokenCreateRequest
 * @version 1.0
 */
class ManagerAccountControllerDtoNotificationTokenCreateRequest {
    /**
     * Constructs a new <code>ManagerAccountControllerDtoNotificationTokenCreateRequest</code>.
     * @alias module:model/ManagerAccountControllerDtoNotificationTokenCreateRequest
     */
    constructor() { 
        
        ManagerAccountControllerDtoNotificationTokenCreateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ManagerAccountControllerDtoNotificationTokenCreateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManagerAccountControllerDtoNotificationTokenCreateRequest} obj Optional instance to populate.
     * @return {module:model/ManagerAccountControllerDtoNotificationTokenCreateRequest} The populated <code>ManagerAccountControllerDtoNotificationTokenCreateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManagerAccountControllerDtoNotificationTokenCreateRequest();

            if (data.hasOwnProperty('token')) {
                obj['token'] = ApiClient.convertToType(data['token'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManagerAccountControllerDtoNotificationTokenCreateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManagerAccountControllerDtoNotificationTokenCreateRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['token'] && !(typeof data['token'] === 'string' || data['token'] instanceof String)) {
            throw new Error("Expected the field `token` to be a primitive type in the JSON string but got " + data['token']);
        }

        return true;
    }


}



/**
 * @member {String} token
 */
ManagerAccountControllerDtoNotificationTokenCreateRequest.prototype['token'] = undefined;






export default ManagerAccountControllerDtoNotificationTokenCreateRequest;

